import styled from "styled-components";

export const ContainerBox = styled.div`
  height: calc(100vh - 56px);
  display: flex;
`;

export const ContentBox = styled.div`
  display: flex;
  height: 100%;
`;

export const Article = styled.div`
  /* padding: 1rem;
  background: #411;
  color: #fff;
  flex: 1; */
`;

export const Title = styled.div`
  font-size: 1.5em;
  text-align: center;
  padding: 10px;
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 500;
`;

export const Content = styled.div`
  position: relative;
  flex: 1;
  /* width: 90vw; */
`;

export const dashBoxStyle = {
  height: 'calc(100vh - 56px)',
  display: 'flex'
}

export const CustomHandle = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 3px;
  cursor: col-resize;
  background-color: var(--mui-blue-light);
  z-index: 999;
`